
/* injects from baggage-loader */

'use strict';

import returnToCompanyTemplate from './returnToCompany.html';

/**
* Function that register the all routes for the returnToCompany module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the returnToCompany page.
	*/
	const indexNav = 6;
	const indexSubmenu= 6;
	const returnToCompanyRoute = {
		state: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].URL,
			templateUrl: returnToCompanyTemplate,
			controller: 'ReturnToCompanyController',
			controllerAs: 'returntocompanyvm',
			resolve: {
				returnToCompany: returnToCompanyLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].SUBMENUS[indexSubmenu].NAME,
				submenu: true
			},
		}
	}


	routerHelper.configureStates([returnToCompanyRoute]);
}

/**
* Function for the lazyLoading configuration in the company to return route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function returnToCompanyLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const returnToCompanyModule = require('./returnToCompany.module');

		$ocLazyLoad.load({
			name: returnToCompanyModule.default.name,
		});

		deferred.resolve(returnToCompanyModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('returnToCompany.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/components/returnToCompany/returnToCompany.route.js